import styled from "styled-components";

const ContentContainer = styled('div')`
    max-width: ${props => props.theme.breakpoints.xxl.breakpoint}px;
    margin: 0 auto;
`;

export default ContentContainer;
